import React from "react";
import HeaderComponent from "../../WebSite/Header/HeaderComponent";
import FooterComponent from "../../WebSite/Footer/FooterComponent";
import CategoryBanner from "../../CategoryBanner/CategoryBanner";
// Main component for AgriService Marketplace

const AgriServiceMarketplace = () => {
  //  Placeholder for category Image

  const categoryImage = {};
  return (
    <>
      {/* Header Component */}

      <HeaderComponent />
      {/* Component showing all categories and services list */}

      <CategoryBanner
        services={true}
        MarketCategoryType="AGR12"
        categoryImage={categoryImage}
        quote="quote"
      />
      {/* Footer Component */}

      <FooterComponent />
    </>
  );
};

export default AgriServiceMarketplace;
